/* Copyright (c) 2017 Backpack Health LLC */

export enum userGroupRole {
  OWNER = 'owner',
  MANAGER = 'manager',
  VIEWER = 'viewer',
}

// since role permissions include administering other users with the same or lower permission level, this is used to determine what roles you can administer
export const adminPermissionLevels = {
  [userGroupRole.VIEWER]: 0,
  [userGroupRole.MANAGER]: 1,
  [userGroupRole.OWNER]: 2,
}

export default userGroupRole;
